import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams, Link, useNavigate } from "react-router-dom";
import { API_servicios } from "../../config/apiConfig";
import { toast } from "react-toastify";
import { FaEnvelope, FaPhone, FaLocationDot, FaClock } from "react-icons/fa6";
import Navbar from "../../components/Navbar";
import "./css/NuevosRecursos.css";
import { API_BASE_URL } from "../../config/apiConfig";

const ServicioAyuntamiento = () => {
  const { id } = useParams(); // Este será el nombre del servicio
  const { role } = useSelector((state) => state.auth);
  const [servicio, setServicio] = useState(null);
  const [loading, setLoading] = useState(true);

  /* Botón eliminar servicio */
  const [mostrarModal, setMostrarModal] = useState(false);
  const navigate = useNavigate();

  const handleCancelar = () => {
    setMostrarModal(true);
  };

  useEffect(() => {
    const fetchServicio = async () => {
      try {
        const response = await fetch(
          `${API_servicios}/${encodeURIComponent(id)}`
        );
        if (!response.ok) {
          throw new Error("Servicio no encontrado");
        }
        const data = await response.json();
        setServicio(data);
      } catch (error) {
        console.error("Error al obtener el servicio:", error);
        setServicio(null);
      } finally {
        setLoading(false);
      }
    };
    fetchServicio();
  }, [id]);

  if (loading) return <p>Cargando servicio...</p>;
  if (!servicio) return <p>No se encontró el servicio.</p>;

  const handleEliminarServicio = async () => {
    try {
      const res = await fetch(
        `${API_BASE_URL}/serviciosAyuntamiento/${encodeURIComponent(
          servicio.nombre
        )}`,
        { method: "DELETE" }
      );
      if (!res.ok) throw new Error();

      toast.success("Servicio eliminado correctamente", { autoClose: 1500 });
      setMostrarModal(false); // cierra el modal
      setTimeout(() => navigate("/admin/social"), 1500);
    } catch (err) {
      toast.error("No se pudo eliminar el servicio");
      console.error(err);
    }
  };

  return (
    <>
      <Navbar />

      <main className="main ofertas-usuario">
        <section className="cabecera between">
          <div className="column gap-5">
            <h1 className="titulo-user">{servicio.nombre}</h1>
            <p className="bold font-18 verde">Servicio Social</p>
          </div>

          <div className="flex gap-10">
            {/* Botones editar y eliminar servicio - solo para administradores y tecnico-1 */}
            {(role === "administrador" || role === "tecnico-1") && (
              <Link
                className="boton"
                to={`/admin/nuevo-servicio-social/${encodeURIComponent(
                  servicio.nombre
                )}`}
              >
                Editar este servicio
              </Link>
            )}
            {role === "administrador" && (
              <button
                className="eliminar fondo-rojo blanco"
                onClick={handleCancelar}
              >
                Eliminar este servicio
              </button>
            )}
          </div>
        </section>

        {mostrarModal && (
          <div className="ventana-cancelar fondo-blanco">
            <div className="column gap-5">
              <p>
                ¿Estás seguro que quieres eliminar el servicio?<br></br>Una vez
                eliminado no habrá forma de recuperarlo
              </p>
              <div className="botones flex gap-20">
                <button
                  className="fondo-rojo blanco"
                  onClick={handleEliminarServicio}
                >
                  Eliminar servicio
                </button>
                <button
                  className="seguir blanco fondo-verde"
                  onClick={() => setMostrarModal(false)}
                >
                  Mantener servicio
                </button>
              </div>
            </div>
          </div>
        )}

        <section className="contenido-principal between">
          <div>
            <h2 className="bold mb-10">Descripción del servicio</h2>
            <p>{servicio.descripcion}</p>

            {/* Mostrar imagen si existe */}
            {servicio.logoUrl && (
              <div className="imagen-recurso mt-20">
                <img
                  src={
                    servicio.logoUrl.startsWith("http")
                      ? servicio.logoUrl
                      : `${API_BASE_URL}/downloads/servicios/${servicio.logoUrl}`
                  }
                  alt={servicio.nombre}
                  className="imagen-detalle"
                  style={{
                    maxWidth: "100%",
                    height: "auto",
                    borderRadius: "8px",
                  }}
                />
              </div>
            )}
          </div>

          <div className="caracteristicas column gap-15">
            {servicio.ubicacion && (
              <p>
                <span className="verde">
                  <FaLocationDot />
                </span>
                {servicio.ubicacion}
              </p>
            )}

            {servicio.telefono && (
              <p>
                <span className="verde">
                  <FaPhone />
                </span>
                {servicio.telefono}
              </p>
            )}

            {servicio.email && (
              <p>
                <span className="verde">
                  <FaEnvelope />
                </span>
                <a href={`mailto:${servicio.email}`} className="verde">
                  {servicio.email}
                </a>
              </p>
            )}

            {servicio.horario && (
              <p>
                <span className="verde">
                  <FaClock />
                </span>
                {servicio.horario}
              </p>
            )}
          </div>
        </section>
      </main>
    </>
  );
};

export default ServicioAyuntamiento;
